import { render } from "./UpdatePasswordForm.vue?vue&type=template&id=43076092"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__